import { Chip } from "@mui/material";
import {
  Get_Active_Workflow_With_Leads,
  Get_Active_Workflows_Activity,
  Get_Appointment_Scheduled,
  Get_Avg_Email_Open_Rate,
  Get_Avg_Lead_Response_Time,
  Get_Email_Conversations_OverTime,
  Get_Email_Received,
  Get_Email_Sent,
  Get_Lead_Lists_In_Workflows,
  Get_Leads_By_Location,
  Get_Leads_Contacted_By_Team_Member,
  Get_Leads_Generated,
  Get_Leads_Not_Contacted,
  Get_Mql_Leads_By_First_Outreach,
  Get_SMS_Received,
  Get_SMS_Sent,
  Get_Unassigned_Leads,
  Get_Workflows_With_SMS_Template,
  Get_Workflows_With_Email_Template,
  Recent_Activity_Created_Leads,
  Get_Leads_By_Status,
  Get_Inbound_Calls_Over_Time,
  Get_Inbound_Calls,
  Get_Lead_Status_By_Average_Annual_Revenue,
  Get_Appointments_Over_Time,
  Get_Appointments_By_Team_Member_Over_Time,
  Get_Lead_To_Appointment_Ratio,
  Get_Lead_To_Appointment_Ratio_Kpi,
} from "../analytics/graphql-queries";
import {
  AbandonedLeadsColumns,
  ActiveWorkflowsWithLeadsColumns,
  AppointmentScheduleColumns,
  EmailReceivedColumns,
  EmailSentColumns,
  LeadListInWorkflowsColumns,
  LeadsGeneratedColumns,
  LeadsNotContactedColumns,
  LeadToAppointmentRatioColumns,
  MQLLeadsByFirstOutReachColumns,
  RecentActivityCreatedLeads,
  SMSReceivedColumns,
  SMSSentColumns,
  UnassignedLeadsColumns,
  WorkflowsWithEmailTemplateColumns,
  WorkflowsWithSMSTemplateColumns,
} from "../leads/constant";
import {
  camelCaseStringToNormalText,
  camelize,
  getFormattedDate,
  getTimezoneAbbreviation,
  groupBy,
} from "@/services/generic.methods";
import { GraphColors } from "@/components/charts/helper";
import {
  ActivityTypeEnumns,
  Enums,
  getObjectKeyByValue,
  WidgetDurationEnums,
} from "@/services/dropdown-enums";
import moment from "moment";
import { GetRangeByDuration } from "../dashboard/helper";

export const time = {
  format: {
    default: "ddd, DD-MMM-YYYY • hh:mm A",
    date: "ddd, DD-MMM-YYYY",
    time: "hh:mm A",
    fetchDate: "ddd, DD-MMM-YYYY hh:mm A",
    isoStringFormat: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
    standardDate: "YYYY-MM-DDTHH:mm:ss",
    dateOnly: "YYYY-MM-DD",
    dateWithTime: "YYYY-MM-DD HH:mm",
    dateAndTime: "dd MMM, YYYY - hh:mm A",
    dateAndTime2: "DD MMM, YYYY - hh:mm A",
    dateAndTimeISOString: "YYYY-MM-DDTHH:mm:ss.SSS",
  },
};

export default {
  time,
};

export const Chart_Types = {
  bar_v_multiple: "bar_v_multiple",
  bar_h_multiple: "bar_h_multiple",
  bar_h_single: "bar_h_single",
  bar_v_single: "bar_v_single",
  line_multiple: "line_multiple",
  line_single: "line_single",
  widget: "widget",
  grid: "grid",
  pie: "pie",
  horizontal_capsule_bar: "horizontal_capsule_bar",
  funnel: "funnel",
};

export const REPORT_NA_VALUE = "N/A";
export const REPORT_NA_OPTION = {
  label: REPORT_NA_VALUE,
  value: REPORT_NA_VALUE,
};

export const ReportEnums = {
  Activity_of_recently_created_leads: 1,
  Leads_contacted_by_team_member: 2,
  Leads_generated: 3,
  MQL_leads_by_first_outreach: 4,
  Leads_by_location: 5,
  Leads_not_contacted: 6,
  Leads_lost: 7,
  Avg_lead_response_time: 8,
  Lead_lists_in_workflows: 9,
  Top_10_lists: 10,
  Avg_email_open_rate: 11,
  Email_conversations_over_time: 12,
  Email_un_subscribe_rate: 13,
  Email_bounce_rate: 14,
  SMS_Delivery_rate: 15,
  SMS_Open_rate: 16,
  Link_clicks_in_SMS: 17,
  Appointment_sent: 18,
  Appointment_booked: 19,
  Lead_to_appointment_ratio: 20,
  Leads_with_social_platforms: 21,
  Email_received: 22,
  Email_sent: 23,
  SMS_sent: 24,
  SMS_received: 25,
  Appointment_Scheduled: 26,
  Unassigned_leads: 27,
  Active_Workflows_Activity_Report: 28,
  Active_Workflows_With_Leads_Report: 29,
  Workflows_With_SMS_Template: 30,
  Workflows_With_Email_Template: 31,
  Task_Status: 32,
  Task_Volume_By_Type: 33,
  Inbound_calls_overtime: 34,
  Inbound_calls: 35,
  Abandoned_Leads: 36,
  Leads_By_Status: 37,
  Email_Clickthrough_Rate: 38,
  Lead_Status_By_Average_Annual_Revenue: 39,
  // Appointments_Booked: 40,
  // Appointments_Rescheduled: 41,
  // Appointments_Canceled: 42,
  Appointments_Over_Time: 43,
  Appointments_By_Team_Member_Over_Time: 44,
  Retainer_Trends_Report: 45,
  Retainer_Overview_Report: 46,
};

export const ReportTemplatesInfo = {
  [ReportEnums.Activity_of_recently_created_leads]: {
    categoryIds: [1],
    query: Recent_Activity_Created_Leads,
    dataKey: "recentActivityCreatedLeads",
    defaultSortKey: "leadId",
    name: "Activity Of Recently Created Leads",
    desc: "Data Table - Lead, Create date, deal stage",
    isKPI: false,
    type: Chart_Types.grid,
    columns: RecentActivityCreatedLeads,
    fields: [
      { type: "date_range", name: "leadStatusChangedOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
    ],
    image: `/assets/app-images/chart-images/1.png`,
  },
  [ReportEnums.Leads_By_Status]: {
    categoryIds: [1],
    query: Get_Leads_By_Status,
    dataKey: "leadsByStatusReport",
    name: "Leads breakdown by lifecycle stages",
    desc: "Capsule - Leads count by status",
    isKPI: false,
    image: `/assets/app-images/chart-images/37.png`,
    type: Chart_Types.horizontal_capsule_bar,
    graphInfo: {
      useFilterPayload: true,
      checkBoxOptionsKey: "LeadStatusId",
      graphDataMapper: (data, statusOptions) => {
        const labels = [];
        const values = [];
        // API returns items with { status, total, percentage }; status = leadStatusId
        if (statusOptions && statusOptions.length) {
          statusOptions.forEach((opt) => {
            labels.push(opt.label);
            const item = (data || []).find(
              (d) => Number(d.status) === Number(opt.value)
            );
            values.push(item ? Number(item.total) : 0);
          });
        } else {
          (data || []).forEach((item) => {
            labels.push(`Status ${item.status}`);
            values.push(Number(item.total));
          });
        }
        return { labels, values };
      },
    },
    fields: [
      {
        type: "date_range",
        name: "createdOn",
        outsideWhere: true,
      },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
    ],
  },
  [ReportEnums.Leads_contacted_by_team_member]: {
    categoryIds: [1],
    query: Get_Leads_Contacted_By_Team_Member,
    dataKey: "leadsContactedByTeamMemberReport",
    name: "Leads Contacted By Team Members",
    desc: "Bar Chart - Team member vs leads",
    isKPI: false,
    type: Chart_Types.bar_h_single,
    graphInfo: {
      checkBoxOptionsKey: "userId",
      graphDataMapper: (data, users) => {
        let obj = {};
        data.forEach((e) => {
          obj = {
            ...obj,
            [e.teamMemberId]: data.filter(
              (a) => a.teamMemberId == e.teamMemberId
            ).length,
          };
        });

        return {
          labels: Object.keys(obj).map((k) => {
            return (
              users.find((f) => f.id == Number(k))?.displayName || "others"
            );
          }),
          values: Object.values(obj),
          color: Object.keys(obj).map(
            (k) => users.find((f) => f.id == Number(k))?.color || GraphColors[5]
          ),
        };
      },
      xLabel: "Number of leads",
      yLabel: () => "Team members",
      staticFilters: [{ teamMemberId: { neq: -2 } }],
      // singleColor: colorEnums.darkBlue.text,
    },
    fields: [
      { type: "date_range", name: "overTime" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "dropdown",
        name: "leadStatusId",
        label: "Select Lead Status",
        options: "leadStatusId",
      },
      {
        type: "checkbox-list",
        name: "teamMemberId",
        options: "leadContactedUsers",
      },
    ],
    image: `/assets/app-images/chart-images/2.png`,
  },
  [ReportEnums.Leads_generated]: {
    categoryIds: [1],
    query: Get_Leads_Generated,
    dataKey: "leadsGeneratedReport",
    name: "Leads Generated",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.grid,
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    columns: LeadsGeneratedColumns,
    withKpi: true,
    kpiInfo: [{ kpiUnit: "" }],
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
        hasNAOption: true,
      },
    ],
  },
  [ReportEnums.MQL_leads_by_first_outreach]: {
    categoryIds: [1],
    query: Get_Mql_Leads_By_First_Outreach,
    dataKey: "mqlLeadsByFirstOutreachReport",
    name: "MQL Leads By First Outreach",
    desc: "KPI",
    isKPI: true,
    paramKey: "overTime",
    type: Chart_Types.grid,
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    withKpi: true,
    kpiInfo: [{ kpiUnit: "%" }],
    columns: MQLLeadsByFirstOutReachColumns,
    fields: [
      { type: "date_range", name: "overTime" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
      {
        type: "checkbox-list",
        name: "teamMemberId",
      },
    ],
  },
  [ReportEnums.Leads_by_location]: {
    categoryIds: [1],
    query: Get_Leads_By_Location,
    dataKey: "leadsByLocationReport",
    name: "Leads By Location",
    desc: "Bar chart - Leads by country/city/state",
    isKPI: false,
    type: Chart_Types.bar_h_single,

    graphInfo: {
      // checkBoxOptionsKey: "StateProvinceId",
      graphOptions: () => {
        return { stepSize: 100 };
      },
      graphDataMapper: (data, knownOptions, filters) => {
        let filterKey =
          filters?.locationBy == 1
            ? "StateProvinceId"
            : filters?.locationBy == 2
              ? "CountryId"
              : filters?.locationBy == 3
                ? "StateProvinceId"
                : "StateProvinceId";

        let sets = groupBy(data, camelize(filterKey), "", filters?.showNull);
        console.log(knownOptions[filterKey]());

        const abc = (arg) => {
          let label = !!Number(arg)
            ? knownOptions[filterKey]
              ? knownOptions[filterKey]().find((s) => s?.id == Number(arg))
              : ""
            : arg;
          return label?.stateProvinceName || label?.countryName || "Other";
        };

        let temp = Object.keys(sets)
          .map((element) => ({
            value: sets[element].reduce((acc, cur) => acc + cur.leadCount, 0),
            label: abc(element),
          }))
          .sort((a, b) => b.value - a.value);

        return {
          labels: temp.map((t) => t.label),
          values: temp.map((t) => t.value),
        };
      },
      xLabel: "Leads",
      yLabel: (filters) => {
        switch (filters?.locationBy) {
          case 1:
            return "States";
          case 2:
            return "Countries";
          case 3:
            return "States";
          case 4:
            return "States";
          default:
            return "States";
        }
      },
      // singleColor: colorEnums.darkBlue.text,
    },
    fields: [
      { type: "date_range", name: "leadCreatedOnDateOnly" },
      {
        type: "checkbox",
        name: "showNull",
        title: "Include leads without location",
      },
      // {
      //   type: "dropdown",
      //   name: "leadSourceId",
      //   label: "Select Lead Source",
      //   options: "leadSourceId",
      // },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
  },
  [ReportEnums.Leads_not_contacted]: {
    categoryIds: [1],
    query: Get_Leads_Not_Contacted,
    dataKey: "leadsNotContactedReport",
    defaultSortKey: "leadId",
    name: "Leads Not Contacted",
    desc: "Data Table - Lead name, assigned to, Date of lead generation",
    isKPI: false,
    type: Chart_Types.grid,
    columns: LeadsNotContactedColumns,
    image: `/assets/app-images/chart-images/1.png`,
    fields: [
      { type: "date_range", name: "dateOfLeadGeneration" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "dropdown",
        name: "assignedTo",
        label: "Select Assignee",
        options: "assignedTo",
      },
    ],
  },
  [ReportEnums.Leads_lost]: {
    categoryIds: [1],
    query: "",
    dataKey: "",
    name: "Leads Lost",
    desc: "Line chart - Leads lost per time",
    isKPI: false,
    type: "",
  },
  [ReportEnums.Avg_lead_response_time]: {
    categoryIds: [1],
    query: Get_Avg_Lead_Response_Time,
    dataKey: "avgLeadResponseTimeReport",
    name: "Avg Lead Response Time",
    desc: "Line chart - Avg lead response time by team",
    isKPI: false,
    type: Chart_Types.line_multiple,
    image: `/assets/app-images/chart-images/8.png`,
    graphInfo: {
      checkBoxOptionsKey: "userId",
      graphDataMapper: (data, users = [], filters) => {
        // Step 1: Create a map of user IDs to user display names
        const userMap = {};
        if (users?.length)
          users.forEach((user) => {
            userMap[user.id] = { color: user.color, name: user.displayName };
          });

        // Step 2: Create an array for labels (unique dates) and a map to store the counts by user
        const labelsSet = new Set();
        const valuesMap = {};

        // Step 3: Populate labelsSet and valuesMap
        // labelsSet.add(date);
        data.forEach((entry) => {
          const date = (entry?.firstOutreachTime || "").split("T")[0]; // Extract the date part
          const leadOwnerId = entry?.leadOwnerId;

          labelsSet.add(date);

          if (!valuesMap[leadOwnerId]) {
            valuesMap[leadOwnerId] = {};
          }

          if (!valuesMap[leadOwnerId][date]) {
            valuesMap[leadOwnerId][date] = [];
          }

          valuesMap[leadOwnerId][date].push(entry);
        });

        AddDatesToSet(labelsSet, "firstOutreachTime", filters);

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();

        // Step 4: Convert the valuesMap to the desired format with missing dates filled with 0
        const values = Object.keys(valuesMap).map((ownerId, index) => {
          return {
            label: userMap[ownerId]?.name || "",
            values: labels.map((label) => {
              let temp = {};
              if (valuesMap[ownerId][label])
                temp = valuesMap[ownerId][label].reduce((acc, crr) => {
                  return {
                    avgResponseTimeMinutes:
                      acc?.avgResponseTimeMinutes + crr?.avgResponseTimeMinutes,
                    totalLeads: acc?.totalLeads + crr?.totalLeads,
                  };
                });
              let avg = Math.ceil(
                temp?.avgResponseTimeMinutes / temp?.totalLeads
              );

              return avg || 0;
            }),
            color: userMap[ownerId]?.color || GraphColors[0],
          };
        });
        return { labels, values };
      },
      xLabel: "date_range",
      yLabel: () => "Duration (mins)",
    },
    icon: "lineChart",
    fields: [
      { type: "date_range", name: "firstOutreachTime" },
      {
        type: "dropdown",
        name: "leadStatusId",
        label: "Select Lead Status",
        options: "leadStatusId",
      },
      {
        type: "checkbox-list",
        name: "leadOwnerId",
        title: "Owners",
      },
    ],
  },
  [ReportEnums.Lead_lists_in_workflows]: {
    categoryIds: [2, 6],
    query: Get_Lead_Lists_In_Workflows,
    dataKey: "leadListsInWorkflowsReport",
    name: "Lead Lists In Automations",
    desc: "Data Table - List name, created by, Created on, automation used in",
    isKPI: false,
    defaultSortKey: false,
    type: Chart_Types.grid,
    image: `/assets/app-images/chart-images/1.png`,
    columns: LeadListInWorkflowsColumns,
    fields: [{ type: "date_range", name: "createdOn" }],
  },
  [ReportEnums.Top_10_lists]: {
    categoryIds: [2],
    query: "",
    dataKey: "",
    name: "Top 10 Lists",
    desc: "Horizontal bar chart - Top 10 lead list",
    isKPI: false,
    type: Chart_Types.bar_h_single,
  },
  [ReportEnums.Avg_email_open_rate]: {
    categoryIds: [3],
    query: Get_Avg_Email_Open_Rate,
    dataKey: "avgEmailOpenRateReport",
    name: "Avg Email Open Rate",
    desc: "Line chart - email open per day",
    isKPI: false,
    type: Chart_Types.line_single,
    image: `/assets/app-images/chart-images/13.png`,
    graphInfo: {
      checkBoxOptionsKey: "userId",
      graphDataMapper: (data, users, filters) => {
        // Step 1: Create a map of user IDs to user display names
        // let temp = [...data];
        const userMap = {};
        if (users?.length)
          users.forEach((user) => {
            userMap[user.id] = { color: user.color, name: user.displayName };
          });
        // Step 2: Create an array for labels (unique dates) and a map to store the counts by date
        const labelsSet = new Set();

        const countsByDate = {};
        let temp = data.filter((d) => d.openRate);
        // Step 3: Populate labelsSet and countsByDate
        temp.forEach((entry) => {
          const date = entry?.emailSentDate?.split("T")[0]; // Extract the date part
          labelsSet.add(date);

          if (!countsByDate[date]) {
            countsByDate[date] = [];
          }
          countsByDate[date].push(entry?.openRate);
        });

        AddDatesToSet(labelsSet, "emailSentDate", filters);

        let valueObj = {};
        Object.keys(countsByDate).forEach((key) => {
          let count = countsByDate[key].reduce((acc, cur) => acc + cur, 0);
          valueObj[key] = count / countsByDate[key].length;
        });

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();

        // Step 4: Create the values array with counts for each date
        const values = labels.map((label) => Math.ceil(valueObj[label] || 0));

        return { labels, values };
      },
      xLabel: "date_range",
      yLabel: () => "Email open rate",
      staticFilters: [{ openRate: { neq: 0 } }],
      unit: "%",
      color: GraphColors[3],
    },
    fields: [
      { type: "date_range", name: "emailSentDate" },
      // {
      //   type: "api-dropdown",
      //   name: "leadId",
      //   label: "Lead Name",
      //   options: "leadName",
      // },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
  },
  [ReportEnums.Email_conversations_over_time]: {
    categoryIds: [3],
    query: Get_Email_Conversations_OverTime,
    dataKey: "emailConversationsOverTime",
    name: "Email Conversations Over Time",
    desc: "Line chart - emails per time",
    isKPI: false,
    type: Chart_Types.line_multiple,
    image: `/assets/app-images/chart-images/13.png`,
    graphInfo: {
      checkBoxOptionsKey: "userId",
      graphDataMapper: (data, users, filters) => {
        const userMap = {};
        users.forEach((user) => {
          userMap[user.id] = { color: user.color, name: user.displayName };
        });

        // Step 2: Create an array for labels (unique dates) and a map to store the counts by user
        const labelsSet = new Set();
        const valuesMap = {};

        // Step 3: Populate labelsSet and valuesMap
        data.forEach((entry) => {
          const date = (entry?.emailSentDate || "").split("T")[0]; // Extract the date part
          const leadOwnerId = entry?.teamMemberId;

          labelsSet.add(date);

          if (!valuesMap[leadOwnerId]) {
            valuesMap[leadOwnerId] = {};
          }

          if (!valuesMap[leadOwnerId][date]) {
            valuesMap[leadOwnerId][date] = 0;
          }

          valuesMap[leadOwnerId][date] += 1;
        });

        AddDatesToSet(labelsSet, "emailSentDate", filters);

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();

        // Step 4: Convert the valuesMap to the desired format with missing dates filled with 0
        const values = Object.keys(valuesMap).map((leadOwnerId, index) => {
          return {
            label: userMap[leadOwnerId]?.name || "",
            values: labels.map((label) => valuesMap[leadOwnerId][label] || 0),
            color: userMap[leadOwnerId]?.color,
          };
        });
        return { labels, values };
      },
      xLabel: "date_range",
      yLabel: () => "Conversations",
      color: GraphColors[0],
    },
    icon: "lineChart",
    fields: [
      { type: "date_range", name: "emailSentDate" },
      // {
      //   type: "api-dropdown",
      //   name: "leadId",
      //   label: "Lead Name",
      //   options: "leadName",
      // },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "checkbox-list",
        name: "teamMemberId",
      },
    ],
  },
  [ReportEnums.Email_un_subscribe_rate]: {
    categoryIds: [3],
    query: "",
    dataKey: "",
    name: "Email Un-subscribe Rate",
    desc: "Line chart - Users unsubscribing emails over time",
    isKPI: false,
    type: Chart_Types.line_single,
    image: `/assets/app-images/chart-images/13.png`,
  },
  [ReportEnums.Email_bounce_rate]: {
    categoryIds: [3],
    query: "",
    dataKey: "",
    name: "Email Bounce Rate",
    desc: "Line chart - Email bouncing over time",
    isKPI: false,
    type: Chart_Types.line_single,
  },
  [ReportEnums.SMS_Delivery_rate]: {
    categoryIds: [4],
    query: "",
    dataKey: "",
    name: "SMS Delivery Rate",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
  },
  [ReportEnums.SMS_Open_rate]: {
    categoryIds: [4],
    query: "",
    dataKey: "",
    name: "SMS Open Rate",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
  },
  [ReportEnums.Link_clicks_in_SMS]: {
    categoryIds: [4],
    query: "",
    dataKey: "",
    name: "Link Clicks In SMS",
    desc: "Bar Chart - SMS link clicks by leads over time",
    isKPI: false,
    type: Chart_Types.bar_v_multiple,
    image: `/assets/app-images/chart-images/17.png`,
  },
  [ReportEnums.Appointment_sent]: {
    categoryIds: [5],
    query: "",
    dataKey: "",
    name: "Appointment Sent",
    desc: "Bar Chart - appointments from sales rep",
    isKPI: false,
    type: "",
  },
  [ReportEnums.Appointment_booked]: {
    categoryIds: [5],
    query: "",
    dataKey: "",
    name: "Appointment Booked",
    desc: "Bar Chart - appointments from sales rep",
    isKPI: false,
    type: Chart_Types.bar_v_multiple,
    image: `/assets/app-images/chart-images/19.png`,
  },
  [ReportEnums.Lead_to_appointment_ratio]: {
    categoryIds: [5],
    query: Get_Lead_To_Appointment_Ratio,
    dataKey: "leadToAppointmentRatioReport",
    name: "Lead To Appointment Ratio",
    columns: LeadToAppointmentRatioColumns,
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    desc: "KPI",
    isKPI: false,
    type: Chart_Types.grid,
    withKpi: true,
    kpiInfo: [
      {
        kpiQuery: Get_Lead_To_Appointment_Ratio_Kpi,
        kpiDataKey: "leadToAppointmentRatioKpi",
        kpiItemKey: "appointmentConversionPercent",
        kpiUnit: "%",
      },
    ],
    graphInfo: {},
    // outsideWhere: true,
    fields: [
      {
        type: "date_range",
        name: "leadCreatedOn",
        // outsideWhere: true,
      },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
    image: `/assets/app-images/chart-images/chart-pie.png`,
  },
  [ReportEnums.Leads_with_social_platforms]: {
    categoryIds: [7],
    query: "",
    dataKey: "",
    name: "Leads With Social Platforms",
    desc: "Data Table - Lead name, created by (Facebook/Twitter/LinkedIn)",
    isKPI: false,
    type: "",
  },
  [ReportEnums.Email_received]: {
    categoryIds: [3],
    query: Get_Email_Received,
    dataKey: "emailReceivedReport",
    name: "Email Received",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.grid,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    columns: EmailReceivedColumns,
    withKpi: true,
    kpiInfo: [{ kpiUnit: "" }],
  },
  [ReportEnums.Email_sent]: {
    categoryIds: [3],
    query: Get_Email_Sent,
    dataKey: "emailSentReport",
    name: "Email Sent",
    desc: "KPI",
    isKPI: true,
    withKpi: true,
    kpiInfo: [{ kpiUnit: "" }],
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    type: Chart_Types.grid,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
    columns: EmailSentColumns,
  },
  [ReportEnums.SMS_sent]: {
    categoryIds: [4],
    query: Get_SMS_Sent,
    dataKey: "smsSentReport",
    name: "SMS Sent",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.grid,
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    withKpi: true,
    kpiInfo: [{ kpiUnit: "" }],
    columns: SMSSentColumns,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
  },
  [ReportEnums.SMS_received]: {
    categoryIds: [4],
    query: Get_SMS_Received,
    dataKey: "smsReceivedReport",
    name: "SMS Received",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.grid,
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    withKpi: true,
    kpiInfo: [{ kpiUnit: "" }],
    columns: SMSReceivedColumns,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
    ],
  },
  [ReportEnums.Appointment_Scheduled]: {
    categoryIds: [5],
    query: Get_Appointment_Scheduled,
    dataKey: "appointmentScheduledReport",
    name: "Appointment Scheduled",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.grid,
    withKpi: true,
    kpiInfo: [{ kpiUnit: "" }],
    gridStyles: { minHeight: "calc(100vh - 275px)" },
    fields: [
      { type: "date_range", name: "startDate" },
      {
        type: "dropdown",
        name: "leadSourceId",
        label: "Select Lead Source",
        options: "leadSourceId",
      },
      {
        type: "location-comp",
        name: "leadLocation",
        label: "Select Lead Location",
        options: "stateProvinceId",
      },
      {
        type: "checkbox-list",
        name: "memberId",
        options: "memberId",
        // title: "Team",
      },
    ],
    columns: AppointmentScheduleColumns,
  },
  [ReportEnums.Unassigned_leads]: {
    categoryIds: [1],
    query: Get_Unassigned_Leads,
    dataKey: "unassignedLeadsReport",
    name: "Unassigned Leads",
    desc: "Data Table - Lead, Create date",
    isKPI: false,
    type: Chart_Types.grid,
    columns: UnassignedLeadsColumns,
    fields: [{ type: "date_range", name: "createdOn" }],
  },
  [ReportEnums.Active_Workflows_Activity_Report]: {
    categoryIds: [6],
    query: Get_Active_Workflows_Activity,
    dataKey: "activeWorkflowsActivityReport",
    name: "Active Automations Activity",
    desc: "Line chart - Timely activity of email and sms sent",
    isKPI: false,
    type: Chart_Types.line_multiple,
    image: `/assets/app-images/chart-images/8.png`,
    graphInfo: {
      graphOptions: () => {
        return { showLegend: true };
      },
      graphDataMapper: (data = [], workflows = [], filters) => {
        // Step 1: Create a map of user IDs to user display names
        const flows = {};
        workflows.forEach((workflow, i) => {
          flows[workflow.id] = {
            color: workflow.color || GraphColors[i],
            name: workflow.name,
          };
        });

        // Step 2: Create an array for labels (unique dates) and a map to store the counts by date
        const labelsSet = new Set();
        const countsByDate = [];

        // Step 3: Populate labelsSet and countsByDate
        data.forEach((entry) => {
          const date = entry.activityDate?.split("T")[0]; // Extract the date part

          labelsSet.add(date);

          // if (!countsByDate[date]) {
          //   countsByDate[date] = 0;
          // }

          // countsByDate[date] += 1;
        });

        AddDatesToSet(labelsSet, "activityDate", filters);

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();
        let sets = groupBy(data, "workFlowId");

        Object.keys(sets).forEach((set, index) => {
          let tempValues = labels.map((l) => {
            let temp = sets[set].filter(
              (f) => f.activityDate?.split("T")[0] == l
            );
            let arr = [];

            Object.values(ActivityTypeEnumns).forEach((a) => {
              let count = temp
                .filter((t) => t.activityTypeId == a)
                .reduce((acc, section) => acc + section?.leadCount || 0, 0);
              arr.push(count);
            });
            let value = arr.reduce((acc, section) => acc + section || 0, 0);

            arr.splice(0, 0, value);
            return arr;
          });

          countsByDate.push({
            label: flows[set]?.name || "",
            values: tempValues,
            color: flows[set]?.color || GraphColors[index],
          });
        });
        // Step 4: Create the values array with counts for each date
        const values = [...countsByDate];

        return { labels, values };
      },
      checkBoxOptionsKey: "workflows",
      xLabel: "date_range",
      yLabel: () => "Activities",
      customTooltip: ({ values }) => ({
        label: ({ dataIndex, datasetIndex, dataset }) => {
          let data = values[datasetIndex]?.values[dataIndex];
          let otherLabels = [];
          Object.keys(ActivityTypeEnumns).forEach((key, index) => {
            if (data[index + 1])
              otherLabels.push(`${key} : ${data[index + 1]}`);
          });
          let label = dataset.label || "Activity";
          return [`  ${label} : ${data[0]}`, ...otherLabels];
        },
      }),
    },
    fields: [
      { type: "date_range", name: "activityDate" },
      {
        type: "dropdown",
        name: "activityTypeId",
        label: "Select Response Type",
        options: [
          /* Enum used from activityType email received, and sms recevied */
          { label: "SMS", value: 1 },
          { label: "Email", value: 2 },
        ],
      },
      {
        title: "Automations",
        type: "checkbox-list",
        name: "workFlowId",
        options: "workflows",
      },
    ],
  },
  [ReportEnums.Active_Workflows_With_Leads_Report]: {
    categoryIds: [6],
    query: Get_Active_Workflow_With_Leads,
    dataKey: "activeWorkflowsWithLeadsReport",
    name: "Active Automations With Leads",
    desc: "Data Table - Number of leads enrolled",
    isKPI: false,
    type: Chart_Types.grid,
    columns: ActiveWorkflowsWithLeadsColumns,
    image: `/assets/app-images/chart-images/1.png`,
    fields: [
      { type: "date_range", name: "workflowCreatedOn" },
      {
        type: "slider",
        name: "numberOfLeadsEnrolled",
      },
    ],
  },
  [ReportEnums.Workflows_With_Email_Template]: {
    categoryIds: [6],
    query: Get_Workflows_With_Email_Template,
    dataKey: "workflowsWithEmailTemplateReport",
    name: "Automations With Email Template",
    desc: "Data Table - Number of leads enrolled",
    isKPI: false,
    type: Chart_Types.grid,
    columns: WorkflowsWithEmailTemplateColumns,
    image: `/assets/app-images/chart-images/1.png`,
    fields: [{ type: "date_range", name: "createdOn" }],
  },
  [ReportEnums.Workflows_With_SMS_Template]: {
    categoryIds: [6],
    query: Get_Workflows_With_SMS_Template,
    dataKey: "workflowWithSMSTemplatesReport",
    name: "Automations With SMS Template",
    desc: "Data Table - Number of leads enrolled",
    isKPI: false,
    type: Chart_Types.grid,
    columns: WorkflowsWithSMSTemplateColumns,
    image: `/assets/app-images/chart-images/1.png`,
    fields: [{ type: "date_range", name: "createdOn" }],
  },
  [ReportEnums.Task_Status]: {
    categoryIds: [7],
    // query: Get_Task_Status,
    dataKey: "taskStatusReport",
    name: "Task Status",
    desc: "Pie chart - Timely activity of email and sms sent",
    isKPI: false,
    type: Chart_Types.pie,
    image: `/assets/app-images/chart-images/8.png`,
    graphInfo: {
      graphDataMapper: (data, workflows, filters) => {
        // Object.keys(sets).forEach((set) => {
        //   let tempValues = labels.map((l) => {
        //     let temp = sets[set].filter(
        //       (f) => f.activityDate?.split("T")[0] == l
        //     );
        //     let arr = [];

        //     Object.values(ActivityTypeEnumns).forEach((a) => {
        //       let count = temp
        //         .filter((t) => t.activityTypeId == a)
        //         .reduce((acc, section) => acc + section?.leadCount || 0, 0);
        //       arr.push(count);
        //     });
        //     let value = arr.reduce((acc, section) => acc + section || 0, 0);

        //     arr.splice(0, 0, value);
        //     return arr;
        //   });

        //   countsByDate.push({
        //     label: flows[set]?.name || "",
        //     values: tempValues,
        //     color: flows[set]?.color,
        //   });
        // });
        // // Step 4: Create the values array with counts for each date
        // const values = [...countsByDate];

        return { labels: ["todo", "process", "done"], values: [40, 30, 76] };
      },
      checkBoxOptionsKey: "TaskStatusId",
      xLabel: "date_range",
      yLabel: () => "Activities",
      // customTooltip: ({ values }) => ({
      //   label: ({ dataIndex, datasetIndex, dataset }) => {
      //     let data = values[datasetIndex]?.values[dataIndex];
      //     let otherLabels = [];
      //     Object.keys(ActivityTypeEnumns).forEach((key, index) => {
      //       if (data[index + 1])
      //         otherLabels.push(`${key} : ${data[index + 1]}`);
      //     });
      //     let label = dataset.label || "Activity";
      //     return [`  ${label} : ${data[0]}`, ...otherLabels];
      //   },
      // }),
    },
    fields: [
      { type: "date_range", name: "dueDate" },
      {
        type: "dropdown",
        name: "taskStatusId",
        label: "Select Task Status",
        options: "taskStatusId",
      },
    ],
  },
  [ReportEnums.Task_Volume_By_Type]: {
    categoryIds: [7],
    // query: Get_Task_Volume_By_Type,
    dataKey: "taskVolumeByTypeReport",
    name: "Task Volume By Type",
    desc: "Pie chart - Timely activity of email and sms sent",
    isKPI: false,
    type: Chart_Types.pie,
    image: `/assets/app-images/chart-images/8.png`,
    graphInfo: {
      graphDataMapper: (data, workflows, filters) => {
        // Step 1: Create a map of user IDs to user display names
        const flows = {};
        workflows.forEach((workflow) => {
          flows[workflow.id] = {
            color: workflow.color,
            name: workflow.displayName,
          };
        });

        // Step 2: Create an array for labels (unique dates) and a map to store the counts by date
        const labelsSet = new Set();
        const countsByDate = [];

        // Step 3: Populate labelsSet and countsByDate
        data.forEach((entry) => {
          const date = entry.activityDate?.split("T")[0]; // Extract the date part

          labelsSet.add(date);

          // if (!countsByDate[date]) {
          //   countsByDate[date] = 0;
          // }

          // countsByDate[date] += 1;
        });

        AddDatesToSet(labelsSet, "activityDate", filters);

        // Convert labelsSet to an array and sort it
        const labels = Array.from(labelsSet).sort();
        let sets = groupBy(data, "workFlowId");

        Object.keys(sets).forEach((set) => {
          let tempValues = labels.map((l) => {
            let temp = sets[set].filter(
              (f) => f.activityDate?.split("T")[0] == l
            );
            let arr = [];

            Object.values(ActivityTypeEnumns).forEach((a) => {
              let count = temp
                .filter((t) => t.activityTypeId == a)
                .reduce((acc, section) => acc + section?.leadCount || 0, 0);
              arr.push(count);
            });
            let value = arr.reduce((acc, section) => acc + section || 0, 0);

            arr.splice(0, 0, value);
            return arr;
          });

          countsByDate.push({
            label: flows[set]?.name || "",
            values: tempValues,
            color: flows[set]?.color,
          });
        });
        // Step 4: Create the values array with counts for each date
        const values = [...countsByDate];

        return { labels, values };
      },
      checkBoxOptionsKey: "workflows",
      xLabel: "date_range",
      yLabel: () => "Activities",
      customTooltip: ({ values }) => ({
        label: ({ dataIndex, datasetIndex, dataset }) => {
          let data = values[datasetIndex]?.values[dataIndex];
          let otherLabels = [];
          Object.keys(ActivityTypeEnumns).forEach((key, index) => {
            if (data[index + 1])
              otherLabels.push(`${key} : ${data[index + 1]}`);
          });
          let label = dataset.label || "Activity";
          return [`  ${label} : ${data[0]}`, ...otherLabels];
        },
      }),
    },
    fields: [{ type: "date_range", name: "createdOn" }],
  },
  [ReportEnums.Inbound_calls_overtime]: {
    categoryIds: [1],
    query: Get_Inbound_Calls_Over_Time,
    dataKey: "inboundCallsOverTimeReport",
    name: "Inbound Calls Over Time",
    desc: "Line chart - Inbound Calls Over Time",
    isKPI: false,
    type: Chart_Types.line_single,
    image: `/assets/app-images/chart-images/8.png`,
    graphInfo: {
      // checkBoxOptionsKey: "userId",
      graphDataMapper: (data, users = [], filters) => {
        // Step 1: Create a map of user IDs to user display names
        const aggregatedData = data.reduce((acc, item) => {
          const date = item.createdOn.split("T")[0]; // extract date part only
          if (!acc[date]) acc[date] = 0;
          acc[date] += item.totalInboundCalls;
          return acc;
        }, {});

        // Step 2: Prepare Chart.js labels and data
        const labels = Object.keys(aggregatedData).sort(); // sorted dates
        const values = labels.map((date) => aggregatedData[date]);

        return { labels, values };
      },
      xLabel: "date_range",
      yLabel: () => "No. of Inbound Calls",
      color: GraphColors[3],
    },
    icon: "lineChart",
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "representativeName",
        label: "Agent Name",
        options: "representativeName",
      },
      // {
      //   type: "checkbox-list",
      //   name: "leadOwnerId",
      //   title: "Owners",
      // },
    ],
  },
  [ReportEnums.Inbound_calls]: {
    categoryIds: [3],
    query: Get_Inbound_Calls,
    dataKey: "inboundCallReport",
    name: "Inbound Calls",
    desc: "KPI",
    isKPI: true,
    type: Chart_Types.widget,
    fields: [
      { type: "date_range", name: "createdOn" },
      {
        type: "dropdown",
        name: "representativeName",
        label: "Agent Name",
        options: "representativeName",
      },
    ],
    columns: [
      {
        title: "Date",
        name: "createdOn",
        render: (data) => getFormattedDate(data?.createdOn, "DD/MM/YYYY"),
      },
      {
        title: "Answered",
        name: "answered",
      },
      {
        title: "Abandoned",
        name: "abandoned",
      },
      {
        title: "Total",
        name: "total",
      },
    ],
  },
  [ReportEnums.Abandoned_Leads]: {
    categoryIds: [1],
    // query: Get_Abandoned_Leads,
    dataKey: "abandonedLeadReport",
    defaultSortKey: "leadId",
    name: "Abandoned Leads",
    desc: "Data Table - Lead, Create date, deal stage",
    isKPI: false,
    type: Chart_Types.grid,
    columns: AbandonedLeadsColumns,
    fields: [
      { type: "date_range", name: "dateCreated" },
      {
        type: "dropdown",
        name: "assignedTo",
        label: "Select Assignee",
        options: "assignedTo",
      },
    ],
    image: `/assets/app-images/chart-images/1.png`,
  },
  [ReportEnums.Lead_Status_By_Average_Annual_Revenue]: {
    categoryIds: [1],
    query: Get_Lead_Status_By_Average_Annual_Revenue,
    dataKey: "leadStatusByAverageAnnualRevenueReport",
    // defaultSortKey: "leadId",
    name: "Lead Status By Average Annual Revenue",
    desc: "Funnel Chart - Lead Status vs Average Annual Revenue",
    isKPI: false,
    type: Chart_Types.funnel,
    defaultfilters: {
      startDate: {
        startDate: null,
        endDate: null,
      },
    },
    // useFilterPayload: true,
    outsideWhere: true,
    // columns: AbandonedLeadsColumns,
    // fields: [{ type: "date_range", name: "dateCreated" }],
    fields: [
      {
        type: "date_range",
        name: "startDate",
        outsideWhere: true,
      },
      {
        title: "Lead Status",
        type: "checkbox-list",
        name: "leadStatusId",
        options: "leadStatusId",
        showColor: false,
      },
    ],
    image: `/assets/app-images/chart-images/2.png`,
    graphInfo: {
      checkBoxOptionsKey: "LeadStatusId",
      xLabel: "% of Total Leads",
      yLabel: "Lead Status",
      graphDataMapper: (data, statusOptions) => {
        let items = [];

        if (data && statusOptions?.length) {
          data.forEach((item) => {
            const status = statusOptions.find(
              (s) => s.id === item.leadStatusId
            );
            if (status) {
              items.push({
                label: status.name,
                value: item.averageAnnualRevenue || 0,
                percentage: item.percentage || 0,
              });
            }
          });
        }

        // Sort by value in descending order (largest to smallest)
        items = items
          .filter((f) => f.percentage >= 0.1)
          .sort((a, b) => b.percentage - a.percentage);

        return {
          labels: items.map((item) => item.label),
          values: items.map((item) => ({
            value: item.value,
            percentage: item.percentage,
          })),
        };
      },
    },
  },
  [ReportEnums.Appointments_Over_Time]: {
    categoryIds: [5],
    query: Get_Appointments_Over_Time,
    dataKey: "appointmentsOverTime",
    name: "Appointments Over Time",
    desc: "Bar chart - Appointments Over Time",
    isKPI: false,
    type: Chart_Types.bar_v_single,
    graphInfo: {
      // checkBoxOptionsKey: "StateProvinceId",
      graphOptions: () => {
        return { stepSize: 100 };
      },
      graphDataMapper: (data, knownOptions, filters) => {
        let date = filters?.bucketDate;
        const start = moment(
          date?.gte || date?.startDate || data[0]?.bucketDate
        );
        const end = moment(
          date?.lte || date?.endDate || data[data.length - 1]?.bucketDate
        );

        if (start && end) {
          const diffDays = end.diff(start, "days");
          const diffMonths = end.diff(start, "months");

          let format;

          if (diffDays <= 7) {
            // ≤ 7 days: Daily with day name (Mon, Jan 1)
            format = "ddd, MMM D";
          } else if (diffDays <= 30) {
            // ≤ 30 days: Daily (Jan 1)
            format = "MMM D";
          } else if (diffMonths < 2) {
            // ≤ 3 months: Weekly (Week 1, Jan)
            format = "[Week] W, MMM";
          } else if (diffMonths <= 12) {
            // ≤ 12 months: Monthly (Jan 2024)
            format = "MMM YYYY";
          } else if (diffMonths <= 24) {
            // ≤ 24 months: Monthly short (Jan '24)
            format = "MMM 'YY";
          } else if (diffMonths <= 36) {
            // ≤ 36 months: Quarterly (Q1 2024)
            format = "[Q]Q YYYY";
          } else {
            // > 36 months: Yearly (2024)
            format = "YYYY";
          }

          const grouped = {};

          if (data.length > 0) grouped[moment(start).format(format)] = 0;

          data.forEach((item) => {
            const key = moment(item.bucketDate).format(format);
            if (item.bookedCount)
              grouped[key] = (grouped[key] || 0) + item.bookedCount;
          });

          // add end date to grouped
          if (data.length > 0) {
            const lastKey = moment(end).format(format);
            grouped[lastKey] = grouped[lastKey] || 0;
          }

          return {
            labels: Object.keys(grouped),
            values: Object.values(grouped),
          };
        }

        let temp = data.map((element) => ({
          value: element?.bookedCount || 0,
          label: (element?.bucketDate || "").split("T")[0],
        }));

        return {
          labels: temp.map((t) => t.label),
          values: temp.map((t) => t.value),
        };
      },
      xLabel: "Leads",
      singleColor: GraphColors[11],
    },
    fields: [{ type: "date_range", name: "bucketDate", outsideWhere: true }],
  },
  [ReportEnums.Appointments_By_Team_Member_Over_Time]: {
    categoryIds: [5],
    query: Get_Appointments_By_Team_Member_Over_Time,
    dataKey: "appointmentsByTeamMemberOverTime",
    name: "Team Appointment Trends",
    desc: "Bar chart - Appointments by team member over time",
    isKPI: false,
    type: Chart_Types.bar_v_single,
    graphInfo: {
      graphDataMapper: (data, knownOptions, filters) => {
        // console.log(data, knownOptions.memberId(), filters, "data");

        const grouped = {};

        data.forEach((item) => {
          const participantKey = item.participantName || item.participantId;
          grouped[participantKey] =
            (grouped[participantKey] || 0) + item.appointmentCount;
        });

        // Optional: Sort by appointment count (highest first)
        const sortedEntries = Object.entries(grouped).sort(
          (a, b) => b[1] - a[1]
        );

        return {
          labels: sortedEntries.map(([label]) => label),
          values: sortedEntries.map(([, value]) => value),
        };
      },
      xLabel: "Team Members",
      yLabel: "Appointments",
    },
    fields: [{ type: "date_range", name: "bucketDate", outsideWhere: true }],
  },
  // [ReportEnums.Retainer_Trends_Report]: {
  //   categoryIds: [6],
  //   query: Get_Active_Workflows_Activity,
  //   dataKey: "activeWorkflowsActivityReport",
  //   name: "Retainer Trends",
  //   desc: "Line chart - Retainer Trends",
  //   isKPI: false,
  //   type: Chart_Types.line_multiple,
  //   image: `/assets/app-images/chart-images/8.png`,
  //   graphInfo: {
  //     graphOptions: () => {
  //       return { showLegend: true };
  //     },
  //     graphDataMapper: (data = [], workflows = [], filters) => {
  //       // // Step 1: Create a map of user IDs to user display names
  //       // const flows = {};
  //       // workflows.forEach((workflow, i) => {
  //       //   flows[workflow.id] = {
  //       //     color: workflow.color || GraphColors[i],
  //       //     name: workflow.name,
  //       //   };
  //       // });

  //       // // Step 2: Create an array for labels (unique dates) and a map to store the counts by date
  //       // const labelsSet = new Set();
  //       // const countsByDate = [];

  //       // // Step 3: Populate labelsSet and countsByDate
  //       // data.forEach((entry) => {
  //       //   const date = entry.activityDate?.split("T")[0]; // Extract the date part

  //       //   labelsSet.add(date);

  //       //   // if (!countsByDate[date]) {
  //       //   //   countsByDate[date] = 0;
  //       //   // }

  //       //   // countsByDate[date] += 1;
  //       // });

  //       // AddDatesToSet(labelsSet, "activityDate", filters);

  //       // // Convert labelsSet to an array and sort it
  //       // const labels = Array.from(labelsSet).sort();
  //       // let sets = groupBy(data, "workFlowId");

  //       // Object.keys(sets).forEach((set, index) => {
  //       //   let tempValues = labels.map((l) => {
  //       //     let temp = sets[set].filter(
  //       //       (f) => f.activityDate?.split("T")[0] == l
  //       //     );
  //       //     let arr = [];

  //       //     Object.values(ActivityTypeEnumns).forEach((a) => {
  //       //       let count = temp
  //       //         .filter((t) => t.activityTypeId == a)
  //       //         .reduce((acc, section) => acc + section?.leadCount || 0, 0);
  //       //       arr.push(count);
  //       //     });
  //       //     let value = arr.reduce((acc, section) => acc + section || 0, 0);

  //       //     arr.splice(0, 0, value);
  //       //     return arr;
  //       //   });

  //       //   countsByDate.push({
  //       //     label: flows[set]?.name || "",
  //       //     values: tempValues,
  //       //     color: flows[set]?.color || GraphColors[index],
  //       //   });
  //       // });
  //       // // Step 4: Create the values array with counts for each date
  //       // const values = [...countsByDate];

  //       // return { labels, values };
  //       return { labels: [], values: [] };
  //     },
  //     // checkBoxOptionsKey: "workflows",
  //     xLabel: "date_range",
  //     yLabel: () => "Number of Retainers",
  //     // customTooltip: ({ values }) => ({
  //     //   label: ({ dataIndex, datasetIndex, dataset }) => {
  //     //     let data = values[datasetIndex]?.values[dataIndex];
  //     //     let otherLabels = [];
  //     //     Object.keys(ActivityTypeEnumns).forEach((key, index) => {
  //     //       if (data[index + 1])
  //     //         otherLabels.push(`${key} : ${data[index + 1]}`);
  //     //     });
  //     //     let label = dataset.label || "Activity";
  //     //     return [`  ${label} : ${data[0]}`, ...otherLabels];
  //     //   },
  //     // }),
  //   },
  //   fields: [
  //     { type: "date_range", name: "activityDate" },
  //     {
  //       title: "Agents",
  //       type: "checkbox-list",
  //       name: "userId",
  //       // options: "workflows",
  //     },
  //   ],
  // },
  // [ReportEnums.Retainer_Overview_Report]: {
  //   categoryIds: [5],
  //   query: Get_Lead_To_Appointment_Ratio,
  //   dataKey: "leadToAppointmentRatioReport",
  //   name: "Retainer Overview",
  //   columns: LeadToAppointmentRatioColumns,
  //   gridStyles: { minHeight: "calc(100vh - 275px)" },
  //   desc: "KPI",
  //   isKPI: false,
  //   type: Chart_Types.grid,
  //   withKpi: true,
  //   kpiInfo: [
  //     {
  //       kpiQuery: Get_Lead_To_Appointment_Ratio_Kpi,
  //       kpiDataKey: "leadToAppointmentRatioKpi",
  //       kpiItemKey: "appointmentConversionPercent",
  //       kpiUnit: "%",
  //     },
  //   ],
  //   graphInfo: {},
  //   // outsideWhere: true,
  //   fields: [
  //     {
  //       type: "date_range",
  //       name: "leadCreatedOn",
  //       // outsideWhere: true,
  //     },
  //     {
  //       type: "dropdown",
  //       name: "leadSourceId",
  //       label: "Select Lead Source",
  //       options: "leadSourceId",
  //     },
  //     {
  //       type: "location-comp",
  //       name: "leadLocation",
  //       label: "Select Lead Location",
  //       options: "stateProvinceId",
  //     },
  //   ],
  //   image: `/assets/app-images/chart-images/chart-pie.png`,
  // },
};

export const ReportExportToastMsg =
  "We're currently preparing your data. Your download will begin automatically as soon as it's ready.";

const AddDatesToSet = (set, key, filters) => {
  let data = filters?.[key];
  if (data) {
    let start = moment(data.startDate).format("YYYY-MM-DD");
    let end = moment(data.endDate).format("YYYY-MM-DD");
    set.add(start);
    set.add(end);
  } else if (filters?.id) {
    const key = getObjectKeyByValue(WidgetDurationEnums, filters?.id);
    const { first } = GetRangeByDuration(key.toLowerCase());
    set.add(moment(first.gte).format("YYYY-MM-DD"));
    set.add(moment(first.lte).format("YYYY-MM-DD"));
  }
};

export const AvailableTemplatesIds = Object.keys(ReportTemplatesInfo)
  .filter((k) => ReportTemplatesInfo[k].query)
  .map((m) => Number(m));
